export const KeepFastCreation = {
    allow: false,
    dataType: '',
    dataTypeName: ''
}